import PageLayout from "@/screens/Layout/PageLayout";
import useIsMobile from "@/hooks/useIsMobile";
import LiveTVPage from "@/screens/LiveTVPage";

export default function Category({
  latestStoryData = null,
  latestVideoData = null,
  faqData = null,
  storyPageData = null,
}) {
  const isMobileDevice = useIsMobile();

  const metaDesc = {
    title: "Aaj Tak LIVE TV - आज तक लाइव टीवी  | Hindi News LIVE TV - NewsTak",
    description:
      "Aaj Tak LIVE TV - आज तक लाइव टीवी: Watch आज तक लाइव टीवी anytime, anywhere, live telecast and streaming online, with coverage of breaking news, the latest politics, sports, entertainment, current affairs, Indian news and world news on NewsTak.in.",
    keywords: `live tv online, tv live, live tv hindi, live tv news channel​, live tv news channel​ free, live tv free, live tv channel, hindi news live tv, live tv streaming​, watch live tv online free​, online live tv​, live tv channel online, live tv channels free online, live tv online free channel​, live tv online india, watch live tv online, live stream tv online, free live tv​,  लाइव टीवी, फ्री लाइव टीवी `,
  };
  const liveTV_id = "livetv-at";
  const title='Aaj Tak Live TV'
  const description = `
<div class=" mt-3  justify-center">
  <h2 class="text-xl font-bold text-gray-700 ">आजतक लाइव टीवी :</h2>
  <p class="text-gray-700 bold ">
    <span class="font-bold">आजतक</span> (Aajtak) India का एक सबसे तेज, प्रतिष्ठित, मशहूर और निष्पक्ष <span >Hindi News Channel</span> है. 
    इसमें News सिर्फ <span >Hindi</span> भाषा में ही दिखाई जाती है. Aajtak News Channel की स्थापना 
    साल 2000 में हुई थी और ये <span >TV Today ग्रुप</span> का हिस्सा है. यह भारत के सबसे बड़े और प्रभावशाली 
    (<span  >impressive</span>) Channels में से एक है.
  </p>

  <h2 class="text-xl font-semibold text-gray-700 ">Aajtak Channel Features :</h2>
  <p class="text-gray-700 bold ">
    आजतक का मेन फोकस <span >Live Coverage</span> और <span >Trending News</span> पर होता है. 
    Aajtak पर आपको सभी तरीके की News दिखाई जाती हैं, जैसे <span >Sports News, Crime News, Business News, 
    International News, Entertainment News</span>, और <span >Political News</span>. 
    आजतक खास कर News की <span >विश्वसनीयता</span> के लिए जाना जाता है.
  </p>

  <h2 class="text-xl font-semibold text-gray-700 ">AajTak पर आने वाले Main Programs :</h2>
  <ul class="list-decimal list-inside  text-gray-700 bold space-y-1">
    <li>दस तक (Das Tak)</li>
    <li>खबरदार (Khabardar)</li>
    <li>हल्ला बोल (Halla Bol)</li>
    <li>धर्म (Dharm)</li>
    <li>चक्के पे चक्का (Chakke Pe Chakka)</li>
    <li>वारदात (Vardat)</li>
    <li>मूवी मसाला (Movie Masala)</li>
    <li>विशेष (Vishesh)</li>
    <li>सीधी बात (Sidhi Baat)</li>
    <li>दंगल (Dangal)</li>
    <li>सास बहु और बेटियां (Saas Bahu Aur Betiyan)</li>
  </ul>

  <h2 class="text-xl font-semibold text-gray-700 ">Digital and Social Media Presence of AajTak :</h2>
  <p class="text-gray-700 bold ">
    आजतक चैनल की सबसे अच्छी बात ये है कि अभी के समय में <span >audience</span> के 
    <span >interest</span> को ध्यान में रखते हुए उन्होंने अपने News को <span >Social Media</span> और 
    <span >Website</span> (<span >Hindi News, हिंदी न्यूज़, Hindi Samachar, हिंदी समाचार, 
    Latest News in Hindi, Breaking News in Hindi, ताजा ख़बरें, Aaj Tak News</span>) पर शानदार तरीके से उपलब्ध कराया है. 
    भारत में आजतक की पहचान <span class="font-bold">नंबर 1 News Channel</span> की है. इसके Viewers की संख्या करोड़ों में है. 
    आजतक दर्शकों को अपने <span >विश्वसनीय News</span> की वजह से पसंद आता है. आज के समय में AajTak की 
    लोकप्रियता काफी अधिक है.
  </p>

  <p class="text-gray-700 bold">
    <span class="font-bold">Aajtak Office Contact No.:</span> 0120-4807100
  </p>
</div>
`;

  return (
    <>
      <PageLayout
        latestStoryData={latestStoryData}
        latestVideoData={latestVideoData}
        isMobileDevice={isMobileDevice}
      >
        <LiveTVPage
          isMobileDevice={isMobileDevice}
          metaDescription={metaDesc}
          liveTV_id={liveTV_id}
          title={title}
          description={description}
          faqData={faqData}
          storyPageData={storyPageData}
        />
      </PageLayout>
    </>
  );
}

export const getServerSideProps = async (ctx) => {
  const { logger } = await import("@/utils/logging/log-util");

  try {
    let url = ctx?.resolvedUrl;
    //* remove query param from url
    url = url.split("?")[0];
    const { getFaqBySlug } = await import("@/handlers/faq");
    const { getLatestStoryVideoFeed, splitLatestStoryVideoFeed, getContentByType } = await import(
      "@/handlers/content"
    );
    const { getRedisApiKey, fetchRedisWrapper } = await import(
      "@/handlers/redisKey"
    );
    const { setPageTTL } = await import("@/utils/setPageTTL");
    const { getUnixTimeDaysAgo } = await import("@/utils/dateTimeFormat");
    const unixtime = getUnixTimeDaysAgo(15);
    //* get page from query param and subtract 1 from it , also error handle if not a number
    let page = ctx?.query?.page;
    if (isNaN(page)) {
      page = 0;
    }
    page = page ? parseInt(page) - 1 : 0;

    //* get redis api key for each api
    const faqRedisKey = getRedisApiKey({
      redisPrefix: "PREFIX_REDIS_ROS",
      params: { api: "staticpages", url: "aajtak-livetv" },
    });
    const latestStoryVideoRedisKey = getRedisApiKey({
      redisPrefix: "PREFIX_REDIS_ROS",
      params: {
        api: "latestcontentfeed",
        page: 0,
        display: 5,
        type: "story,video",
        unixtime,
      },
    });
    const videosRedisKey = getRedisApiKey({
      redisPrefix: "PREFIX_REDIS_ROS",
      params: {
        api: "newslist",
        page: page,
        display: 12,
        type: "video",
      },
    });

    const storiesRedisKey = getRedisApiKey({
      redisPrefix: "PREFIX_REDIS_ROS",
      params: {
        api: "newslist",
        page: page,
        display: 12,
        type: "story",
      },
    });

    
   
    let [faqData,{ latestStoryData, latestVideoData }, storyPageData] = await Promise.all([
      
      fetchRedisWrapper(faqRedisKey, () =>
        getFaqBySlug({
          url: url// 'aajtak-livetv', //"kumbha-faq",
        })
      ),
      fetchRedisWrapper(latestStoryVideoRedisKey, () =>
        getLatestStoryVideoFeed({
          page: 0,
          display: 5,
          unixtime,
        })
      ).then(splitLatestStoryVideoFeed),
      fetchRedisWrapper(videosRedisKey, () =>
        getContentByType({
          type: "video",
          page: page,
          display: 12,
        })
      ),
      fetchRedisWrapper(storiesRedisKey, () =>
        getContentByType({
          type: "story",
          page: page,
          display: 12,
        })
      ),
    ]);
   
    let headerCache = storyPageData?.cache;

    setPageTTL(ctx, headerCache?.akamai_ttl);

    return {
      props: {
        latestStoryData,
        latestVideoData,
        faqData,
        storyPageData,
      },
    };
  } catch (error) {
    logger.error(error);
    return {
      notFound: true,
    };
  }
};
